Vue.prototype.translate = function(messageKey, useGroupedMessageKeyPrefix = true) {
    // look up the translation string in the named resource file for the group
    if (useGroupedMessageKeyPrefix) {
        let messageGroup = messageKey.split('.')[0];
        if (messageGroup !== '') {
            let messageKeySuffix = messageKey.substring(messageGroup.length + 1);
            return _.get(window.translations[messageGroup], messageKeySuffix, messageKeySuffix);
        }
    }

    // return translation string from the default 'messages' resource file
    return _.get(window.translations.messages, messageKey, messageKey);
};